import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const IconCheckMarkWrapper = styled.span`
  width: 16px;
  height: 10px;
  margin-right: 8px;
`

export const LanguagesSelectItem = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: ${colors.mainText};
`

export const LanguagesSelectItemAnimation = styled(LanguagesSelectItem)`
  animation: fade 0.5s ease-in-out;
`

export const GotItContainer = styled.div`
  margin: 0 auto;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const CheckboxLabel = styled.span`
  color: ${colors.mainText};
`
export const PlayListComponentEmptyPageContainer = styled.div`
  border-radius: 4px;
  line-height: 21px;
  font-size: 14px;
  color: #646877;
  @media ${device.mobileMin} {
    padding: 24px;
    background: #ffffff;
    border-radius: 4px;
  }
`

export const PlayListComponentEmptyPagetext = styled.div`
  display: grid;
  margin-bottom: 24px;
`
